import React from "react";
import { useTranslation, Trans } from "react-i18next";

const FAQ_KEYS = [
  "whatDoes",
  "whatIsLoc",
  "howMuch",
  "stillResponsible",
  "changeMyMind",
  "renew",
  "moveOut",
  "vsDeposit",
  "vsInsurance",
];

const FAQ: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-3xl">
      <div className="rounded-xl bg-white shadow-sm">
        <div className="p-6 sm:p-8">
          <h1 className="mb-6 text-2xl font-bold text-primary sm:text-3xl">
            {t("faq.title")}
          </h1>

          <div className="space-y-6">
            {FAQ_KEYS.map((key) => {
              const paragraphs = t(`faq.${key}.answer`, {
                returnObjects: true,
              }) as string[];
              return (
                <section key={key}>
                  <h2 className="mb-2 text-lg font-semibold text-primary">
                    {t(`faq.${key}.question`)}
                  </h2>
                  <div className="space-y-3 text-sm leading-relaxed text-gray-700">
                    {paragraphs.map((_, idx) => (
                      <p key={idx}>
                        <Trans
                          i18nKey={`faq.${key}.answer.${idx}`}
                          components={{ strong: <strong />, em: <em /> }}
                        />
                      </p>
                    ))}
                  </div>
                </section>
              );
            })}

            <p className="border-t border-gray-100 pt-6 text-sm text-gray-700">
              {t("faq.contact")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
